<template>
  <div>
    <div>
      <div class="d-flex" style="position: absolute;" :style="[zIndexModel ? {'z-index' : 0} : {'z-index' : 1}]">
        <Button
          :size="15"
          color="#fd7e14"
          colorText="#ffffff"
          tooltip="Filtrar contenido"
          icon="fas fa-filter"
          round
          :width="30"
          class="mt-2 mb-3 mr-2"
          @click.native="openModal('modal')"
          traslate
        />
        <Button
          :size="15"
          color="#dc3545"
          colorText="#ffffff"
          tooltip="Borrar contenido Filtrado"
          icon="fas fa-filter"
          round
          :width="30"
          class="mt-2 mb-3 mr-2"
          traslate
          @click.native="clear()"
        />
      </div>
    </div>

    <ui-modal ref="modal" title="Filtros para tabla" size="auto">
      <!-- Cuerpo -->
      <div class="d-flex flex-column">
        <!-- Fila 1 -->
        <div class="d-flex flex-column">
          <div class="d-flex">
            <!-- Año -->
            <ui-select
              class="w-50"
              has-search
              label="Año"
              placeholder="Seleccionar"
              searchPlaceholder="Buscar"
              :options="dataListaAnio"
              v-model="anioModel"
            />

            <!-- Semana -->
            <ui-select
              class="w-50 ml-3"
              has-search
              label="Semana"
              placeholder="Seleccionar"
              searchPlaceholder="Buscar"
              :options="dataListaSemana"
              :keys="{ label: 'name', value: 'id' }"
              v-model="semanaModel"
            />
          </div>

          <div class="d-flex">
            <!-- POD -->
            <ui-select
              class="w-50"
              has-search
              label="POD"
              placeholder="Seleccionar"
              searchPlaceholder="Buscar"
              :options="dataListaPOD"
              :keys="{ label: 'name', value: 'id' }"
              v-model="podModel"
            />

            <!-- Producto -->
            <ui-select
              class="w-50 ml-3"
              has-search
              label="Producto"
              placeholder="Seleccionar"
              searchPlaceholder="Buscar"
              :options="dataListaProducto"
              :keys="{ label: 'name', value: 'id' }"
              v-model="productoModel"
            />
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="d-flex justify-content-between mt-5">
        <button class="btn btn-default" @click="closeModal('modal')">
          Cerrar
        </button>
        <div style="float: right">
          <button
            class="btn btn-secondary"
            style="margin-right: 50px"
            @click="clear"
          >
            Limpiar
          </button>
          <button class="btn btn-danger mr-3" @click="filtrarLista" :disabled="!filter_btn_active">
            {{ filter_btn_text }}
          </button>
        </div>
      </div>
    </ui-modal>
  </div>
</template>

<script>
// Vuex
import { mapState, mapActions } from "vuex";
// UI Modal
import UiModal from "keen-ui/src/UiModal";
import UiSelect from "keen-ui/src/UiSelect";

import Button from "../../../common/Button";

import { getVerMisBookingsPorAceptarFiltrados } from "@/constants/lineas";

// Buttom

export default {
  data() {
    return {
      // Modelos
      idBookingModel: "",
      anioModel: "",
      semanaModel: "",
      productoModel: "",
      podModel: "",
      filter_btn_text: "Filtrar",
      filter_btn_active: true,
      dataFilter: this.dataDatatableVerMisBookingsPorAceptarFiltrada
    };
  },
  components: {
    UiModal,
    UiSelect,

    Button
  },
  computed: {
    ...mapState("lineas", [
      "dataDatatableVerMisBookingsPorAceptarFiltrada",
      "dataListaPOD",
      "dataListaSemana",
      "dataListaAnio",
      "dataListaProducto",
      "flagFiltersBookings",
      "currentFiltersBookings"
    ]),
    ...mapState(["productos", "zIndexModel"])
  },
  methods: {
    ...mapActions("lineas", [
      "actionSetDatatableVerMisBookingsPorAceptar",
      "actionFilterDataVerMisBookingsPorAceptar",
      "actionLimpiarDataVerMisBookingsPorAceptar",
      "actionSetFlagFiltersBookings",
      "actionSetCurrentFiltersBookings"
    ]),
    clear() {
      this.anioModel = "";
      this.semanaModel = "";
      this.productoModel = "";
      this.podModel = "";
      this.actionLimpiarDataVerMisBookingsPorAceptar();
      this.actionSetFlagFiltersBookings(false);
      this.actionSetCurrentFiltersBookings({})
      this.loadingButton(true);
    },
    async filtrarLista() {

      this.loadingButton(false);

      this.actionLimpiarDataVerMisBookingsPorAceptar();

      let filters = {
        id: this.idBookingModel ?? null,
        anio: this.anioModel ?? null,
        pod: this.podModel.id ?? null,
        semana: this.semanaModel.id ?? null,
        producto: this.productoModel.id ?? null
      };

      this.actionSetCurrentFiltersBookings(filters);

      let dataFiltrada = await getVerMisBookingsPorAceptarFiltrados(filters);

      this.actionSetFlagFiltersBookings(true);

      this.actionFilterDataVerMisBookingsPorAceptar(dataFiltrada);

      this.loadingButton(true);

      this.closeModal("modal");
    },
    loadingButton(active) {
      if (!active) {
        this.filter_btn_text = "Filtrando...";
        this.filter_btn_active = active;
      } else {
        this.filter_btn_text = "Filtrar";
        this.filter_btn_active = active;
      }
    },
    openModal(ref) {
      this.$refs[ref].open();
    },
    closeModal(ref) {
      this.$refs[ref].close();
    }
  }
};
</script>

<style>
.ui-modal--size-large > .ui-modal__wrapper > .ui-modal__container {
  width: 80rem;
}
</style>
